import { ControlPoint as ControlPointIcon } from '@mui/icons-material';

import { AddMainActionButton } from '@/components/actions';
import { ActionIconButton } from '@/components/buttons';
import {
  useNomenclatureStoreActions,
  useNomenclatureStoreIsContextWindowsVisible,
} from '@/components/nomenclature/useNomenclatureStore';
import { useShortcut } from '@/shared/hooks/useShortcut';

// ----------------------------------------------------------------------

export const NomenclatureCreateButton = () => {
  const { openCreateModal } = useNomenclatureStoreActions();
  const isContextWindowsVisible = useNomenclatureStoreIsContextWindowsVisible();

  useShortcut({
    combination: 'ctrl + n',
    onPressed: () => {
      if (!isContextWindowsVisible) {
        openCreateModal();
      }
    },
  });

  return <AddMainActionButton onClick={openCreateModal} />;
};

// ----------------------------------------------------------------------

export const NomenclatureCreateActionButton = () => {
  const { openCreateModal } = useNomenclatureStoreActions();
  const isContextWindowsVisible = useNomenclatureStoreIsContextWindowsVisible();

  useShortcut({
    combination: 'ctrl + n',
    onPressed: () => {
      if (!isContextWindowsVisible) {
        openCreateModal();
      }
    },
  });

  return (
    <ActionIconButton title="Создать" onClick={openCreateModal}>
      <ControlPointIcon fontSize="medium" />
    </ActionIconButton>
  );
};
